import * as React from 'react';
import { useVariableWithStableRef } from './useVariableWithStableRef';

export function useChangeObserver<TData>(
    data: TData,
    onChange: (newData: TData, oldData?: TData) => void,
    isEqual = (first: TData, second: TData) => first === second
) {
    const onChangeRef = useVariableWithStableRef(onChange);
    const isEqualRef = useVariableWithStableRef(isEqual);
    const [previousData, setPreviousData] = React.useState(data);

    React.useEffect(() => {
        const hasChanged = isEqualRef.current?.(previousData, data) === false;

        if (hasChanged) {
            setPreviousData(data);
            onChangeRef.current?.(data, previousData);
        }
    }, [isEqualRef, onChangeRef, data]);
}
